import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  role: "status",
  "aria-live": "polite"
}

import AppNavbar from '@/components/layout/AppNavbar.vue';
import AppSidebar from '@/components/layout/AppSidebar.vue';
import SearchChatsDialog from '@/components/SearchChatsDialog.vue';
import {
  isAuthenticated as checkAuth,
  keycloak,
  logout,
} from '@/plugins/keycloak';
import { Agent } from '@/services/agentService';
import { type Conversation } from '@/services/conversationService';
import { useAgentStore } from '@/stores/agentStore';
import { useConversationStore } from '@/stores/conversationStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { storage } from '@/utils/localStorage';
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const router = useRouter();
const agentStore = useAgentStore();
const conversationStore = useConversationStore();
const notificationStore = useNotificationStore();
const { mobile: isMobile } = useDisplay();

const drawer = ref(true);
const showSearchDialog = ref(false);
const rail = ref(storage.get<boolean>('sidebar-rail') || false);
const userName = ref('Guest');
const userEmail = ref('');
const isAuthenticated = ref(false);

watch(rail, (newValue) => {
  storage.set('sidebar-rail', newValue);
});

onMounted(async () => {
  isAuthenticated.value = Boolean(checkAuth());

  if (isAuthenticated.value && keycloak.tokenParsed) {
    userName.value =
      keycloak.tokenParsed.preferred_username ||
      keycloak.tokenParsed.name ||
      'User';
    userEmail.value = keycloak.tokenParsed.email || '';
  }

  // Load agents and conversations
  await Promise.all([
    agentStore.loadAgents(),
    conversationStore.loadConversations(),
  ]);
});

const handleSelectConversation = (conversation: Conversation) => {
  agentStore.setSelectedAgent(
    agentStore.getAgentById(conversation.agent.id) || null,
  );
  conversationStore.setSelectedConversation(conversation);
  router.push({
    path: `/en/echo/conversation/${conversation.id}`,
    query: { shouldReset: 'true' },
  });
  console.log('Selected conversation:', conversation);
};

const handleNewChat = (agent: Agent) => {
  agentStore.setSelectedAgent(agent);
  conversationStore.setAgentFilter(null);
  conversationStore.setSelectedConversation(null);
  router.push({
    path: '/en/echo/conversation',
    query: { shouldReset: 'true' },
  });
  console.log(
    'Starting new chat with agent:',
    agentStore.getSelectedAgent()?.name,
  );
};

const handleGoHome = () => {
  conversationStore.setSelectedConversation(null);
  router.push('/en/echo');
};

const handleLogout = () => {
  logout();
};

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(AppSidebar, {
        drawer: drawer.value,
        "onUpdate:drawer": _cache[0] || (_cache[0] = ($event: any) => ((drawer).value = $event)),
        rail: rail.value,
        "onUpdate:rail": _cache[1] || (_cache[1] = ($event: any) => ((rail).value = $event)),
        isMobile: _unref(isMobile),
        agents: _unref(agentStore).agents,
        conversations: _unref(conversationStore).conversations,
        onNewChat: handleNewChat,
        onSelectConversation: handleSelectConversation,
        onOpenSearch: _cache[2] || (_cache[2] = ($event: any) => (showSearchDialog.value = true)),
        onGoHome: handleGoHome
      }, null, 8, ["drawer", "rail", "isMobile", "agents", "conversations"]),
      _createVNode(SearchChatsDialog, {
        modelValue: showSearchDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showSearchDialog).value = $event)),
        agents: _unref(agentStore).agents,
        onSelectConversation: handleSelectConversation,
        onNewChat: handleNewChat
      }, null, 8, ["modelValue", "agents"]),
      _createVNode(AppNavbar, {
        drawer: drawer.value,
        "onUpdate:drawer": _cache[4] || (_cache[4] = ($event: any) => ((drawer).value = $event)),
        isMobile: _unref(isMobile),
        userName: userName.value,
        userEmail: userEmail.value,
        isAuthenticated: isAuthenticated.value,
        onLogout: handleLogout,
        onGoHome: handleGoHome,
        onSelectAgent: handleNewChat
      }, null, 8, ["drawer", "isMobile", "userName", "userEmail", "isAuthenticated"]),
      _createVNode(_component_v_main, { class: "main-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "pa-0 fill-height"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: _unref(notificationStore).show,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(notificationStore).show) = $event)),
        color: _unref(notificationStore).color,
        timeout: 4000
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(notificationStore).message), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"])
    ]),
    _: 3
  }))
}
}

})